import actionCreator from 'helpers/actionCreator'
import { UPDATE_USER_SETTINGS } from 'actions/settingsActionTypes'

/** Called as an action when a user setting value is changed */
export const updateUserSettingsAction = actionCreator(UPDATE_USER_SETTINGS, 'updates')



// WEBPACK FOOTER //
// ./src/actions/settingsActions.js